import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  claimRegister: {
    // Note that the levels are Claims -> Claim New -> Claim Detail
    init: 0,
    initErr: [],
    menu: {},
    riskNoList: [],
    riskGrpNoList: []
  },
  claimListing: {
    init: 0,
    initErr: [],
    menu: {},
    busClsList: [],
    clmStatList: [],
    interList: [],
    nol1List: []
  },
  claimParams: {
    init: 0,
    initErr: [],
    serviceProviderList: [],
    currencyList: [],
    reservesList: [],
    resCurrList: [],
    branchList: [],
    // liabilityList: [],
    bankList: [],
    permitGST: undefined,
    claimTranDateRange: {},
    paymentTranDateRange: {}
    // autoFacXolrcvy: false
  },
  clmMtrDrvr: {

  },
  claimPayment: {
    newHeader: true,
    selectedHeader: {},
    selectedReserves: [],
    resCurr: undefined
  },
  clmHdlr: {
    userList: [],
    handlerList: [],
    loading: false
  },
  claimDetail: {
    init: 0,
    initErr: [],
    menu: {},
    saving: false,
    saveError: {
      fieldMessages: [],
      messages: []
    },
    remove: undefined,
    // Claim Life Cycle state. Controls the steps within the Claim. Starts off as 2 but 1 is reserved for ClaimNew.
    claimLifeCycle: 1,
    promptWhenExit: true,
    selectedClaimant: undefined,
    selectedClmItem: undefined,
    selectedClmReserve: undefined,
    tranDate: undefined,
    enableResCurr: false,
    commonInfo: {
      query: false,
      clmNo: undefined,
      revision: undefined,
      clmNoAe: undefined,
      cseStat: undefined,
      clmStat: undefined,
      polNo: undefined,
      renCnt: undefined,
      endtCnt: undefined,
      branch: undefined,
      polType: undefined,
      notDate: undefined,
      lossDate: undefined,
      lossTime: undefined,
      riskGrpNo: undefined,
      riskNo: undefined,
      clmEvent: undefined,
      clmEventDesc: undefined,
      mocmpNo: undefined,
      insdRefNo: undefined,
      titleName: undefined,
      firstName: undefined,
      insdName1: undefined,
      insdName2: undefined,
      insdName3: undefined,
      insdAddr1: undefined,
      insdAddr2: undefined,
      insdAddr3: undefined,
      insdAddr4: undefined,
      postCode: undefined,
      icNo: undefined,
      othNo: undefined,
      comDate: undefined,
      expDate: undefined,
      endtDate: undefined,
      uwYr: undefined,
      clmYr: undefined,
      acctMth: undefined,
      acctYr: undefined,
      cseLoss: undefined,
      cseLoss1: undefined,
      cseLoss2: undefined,
      cseLoss3: undefined,
      prtCseLossLn: undefined,
      cnNo: undefined,
      dri: undefined,
      busSrc: undefined,
      dept: undefined,
      cty: undefined,
      busCls: undefined,
      siCurr: undefined,
      resCurr: undefined,
      agent: undefined,
      agentSfx: undefined,
      acctNo1: undefined,
      acctNoSfx: undefined,
      fund: undefined,
      finInst: undefined,
      appCoins: undefined,
      billCoins: undefined,
      coInsPct: undefined,
      cedant: undefined,
      cedClmNo: undefined,
      cedPolNo: undefined,
      cedCesNo: undefined,
      recip: undefined,
      paidAmt: undefined,
      planPayt: undefined,
      totRes: undefined,
      paidAmtLoc: undefined,
      planPaytLoc: undefined,
      totResLoc: undefined,
      grossResOS: undefined,
      netRes: undefined,
      recAmt: undefined,
      totRiPct: undefined,
      clmTxt: undefined,
      clmNotNo: undefined,
      phCltGrp: undefined,
      isPhGstreg: undefined,
      gstRegNo: undefined,
      gstRegDate: undefined,
      acceptDate: undefined,
      clmClsType: undefined,
      email: undefined,
      rlatClmRefNo: undefined,
      insdClmRefNo: undefined,
      contrtNo: undefined,
      statDate: undefined,
      isClmFsprtd: undefined,
      insdName4: undefined,
      isAckLtrPrtd: undefined,
      prtAckLtr: undefined,
      appID: undefined,
      claimants: [],
      clmItems: [],
      clmServiceProviders: [],
      clmItemReserves: [],
      claimStatuses: [],
      clmPayts: [],
      clmReses: [],
      clmRiRcvys: [],
      xolRcvys: [],
      excess: {},
      statisticses: [],
      currencyParam: [],
      clmHdlrCount: 0,
      frgnCurrRes: undefined,
      branchDesc: undefined,
      polTypeDesc: undefined,
      busSrcDesc: undefined,
      deptDesc: undefined,
      ctyDesc: undefined,
      busClsDesc: undefined,
      fundDesc: undefined,
      vehMakeDesc: undefined,
      vehModelDesc: undefined,
      createdBy: undefined,
      createdDate: undefined,
      vehVsl: undefined,
      sfxDesc: undefined,
      // Query Claim Added By WeeLe
      agentAcctNoSfx: undefined,
      autoFacXolrcvy: undefined,
      agentName: undefined,
      acctNoName: undefined,
      cedantName: undefined,
      modifiedName: undefined,
      modifiedDate: undefined,
      hasOSRes: undefined,
      refNo: undefined,
      submitReserves: [],
      servicers: [],
      clmAccumRes: [],
      totAccumRes: 0,
      totPlannedRes: 0,
      totPaidRes: 0,
      totAccumResLoc: 0,
      totPlannedLoc: 0,
      totPaidLoc: 0
    }
  },
  clmHasRIOrResAdj: {
    hasRIOrResAdj: false
  },
  clmRIRcvy: {
    init: 0,
    initErr: [],
    menu: {}
  },
  procNotif: {
    show: false,
    notifType: '',
    clmNo: '',
    emailInsured: false,
    emailAddressInsured: '',
    smsInsured: false,
    smsNumberInsured: '',
    emailAgent: false,
    emailAddressAgent: '',
    smsAgent: false,
    smsNumberAgent: '',
    saveError: {
      fieldMessages: [],
      messages: []
    }
  },
  renewalMessage: {
    init: 0,
    initErr: [],
    menu: {}
  },
  loadListing: {
    action: ''
  },
  clmPendExistList: {
    promptFlagRes: false,
    reverseOverLimitList: [],
    promptFlagPay: false,
    paymentOverLimitList: []
  }
}

export default {
  // deep clone here, we need the initialState for resetting of state in ClaimNew
  state: clone(initialState),
  getters,
  mutations,
  actions
}
